import type { QuoteService } from "@/lib/plan-wizard-schema";

/** Per-service copy and fields for the quote form (#1221). Wedding and live
 * service keep the copy they had before. */
interface QuoteBranchConfig {
  heading: string;
  subheading: string;
  submitLabel: string;
  dateLabel: string;
  guestsLabel: string;
  locationLabel: string;
  locationPlaceholder: string;
  locationHint: string;
  showEventTypeChips: boolean;
  showPreferences: boolean;
  showFulfillment: boolean;
  defaultEventTypeName: string;
}

const EVENT_LOCATION = {
  locationLabel: "Where is the event?",
  locationPlaceholder: "e.g. Backyard, banquet hall, or TBD",
  locationHint: "A venue name, address, or general idea is fine.",
};

export const QUOTE_BRANCH_CONFIG: Record<QuoteService, QuoteBranchConfig> = {
  wedding: {
    heading: "Tell us about your wedding",
    subheading:
      "Share a few details and our team will craft a custom menu and quote — we'll reach out within 24 hours.",
    submitLabel: "Get my custom quote",
    dateLabel: "Date",
    guestsLabel: "Estimated guests",
    ...EVENT_LOCATION,
    showEventTypeChips: false,
    showPreferences: true,
    showFulfillment: false,
    defaultEventTypeName: "Wedding",
  },
  live_service: {
    heading: "Tell us about your event",
    subheading:
      "Tell us what you're planning and we'll match the right setup to your event. Expect to hear from us within 24 hours.",
    submitLabel: "Get my custom quote",
    dateLabel: "Date",
    guestsLabel: "Estimated guests",
    ...EVENT_LOCATION,
    showEventTypeChips: true,
    showPreferences: true,
    showFulfillment: false,
    defaultEventTypeName: "",
  },
  corporate: {
    heading: "Tell us about your corporate event",
    subheading: "Share a few details and we'll send you our corporate menu right away. We'll follow up within 24 hours.",
    submitLabel: "Send me the menu",
    dateLabel: "Date",
    guestsLabel: "Estimated guests",
    locationLabel: "Where is the event?",
    locationPlaceholder: "e.g. Your office address",
    locationHint: "An address or general area is fine.",
    showEventTypeChips: false,
    showPreferences: false,
    showFulfillment: false,
    defaultEventTypeName: "Corporate Event",
  },
  drop_off: {
    heading: "Tell us about your order",
    subheading: "Share a few details and we'll send you our take-out menu right away. We'll follow up within 24 hours.",
    submitLabel: "Send me the menu",
    dateLabel: "Delivery or pickup date",
    guestsLabel: "How many people?",
    locationLabel: "Address or area",
    locationPlaceholder: "e.g. 123 Main St, Bolton",
    locationHint: "Where we're delivering to. For pickup you can leave it blank.",
    showEventTypeChips: false,
    showPreferences: false,
    showFulfillment: true,
    defaultEventTypeName: "Drop-off",
  },
};
